const SHOPIFY_API = {
    UPDATE: '/cart/update.js',
    ADD: '/cart/add.js'
}


let currentStep = 0;
let userSelection = [];
let drySelected = false;
let cartItems = [];

const options = [
    "Medium Lotion, Medium Foam, Medium Clear Water, Medium Instant Tan, Light Face Tanning Mist, Light Face Tanning Serum".split(', '),
    "Medium Lotion, Medium Foam, Medium Clear Water, Medium Instant Tan, Light Face Tanning Mist, Light Face Tanning Serum".split(', '),
    "Dark Lotion, Dark Foam, Dark Clear Water, Dark Instant Tan, Medium Face Tanning Mist, Medium Face Tanning Serum".split(', '),
    "Dark Lotion, Dark Foam, Dark Clear Water, Dark Instant Tan, Medium Face Tanning Mist, Medium Face Tanning Serum".split(', '),
    "Ultra Dark Lotion, Ultra Dark Foam, Ultra Dark Instant Tan, Dark Face Tanning Mist, Dark Face Tanning Serum".split(', '),
    "Ultra Dark Lotion, Ultra Dark Foam, Ultra Dark Instant Tan, Dark Face Tanning Mist, Dark Face Tanning Serum".split(', '),
    // questions
    "Medium Lotion, Medium Foam, Medium Clear Water, Medium Instant Tan, Light Face Tanning Mist, Light Face Tanning Serum, Luxury Tanning Mitt, Luxury Body Brush".split(', '),
    "Ultra Dark Lotion, Ultra Dark Foam, Ultra Dark Instant Tan, Dark Face Tanning Mist, Dark Face Tanning Serum, Luxury Tanning Mitt, Luxury Body Brush".split(', '),
    "Dark Lotion, Dark Foam, Dark Clear Water, Dark Instant Tan, Medium Face Tanning Mist, Medium Face Tanning Serum, Luxury Tanning Mitt, Luxury Body Brush".split(', '),
    "Ultra Dark Lotion, Ultra Dark Foam, Ultra Dark Instant Tan, Dark Face Tanning Mist, Dark Face Tanning Serum, Luxury Tanning Mitt, Luxury Body Brush".split(', ')
];

const elements = {
    'wrapper': document.querySelectorAll('.bbv-match-finder > .container'),
    'stepCounter': document.getElementById('bbv-match-finder-current-step'),
    'steps': document.querySelectorAll('.bbv-match-finder__step'),
    'actions': document.querySelectorAll('.button[data-action]'),
    'buttons': document.querySelectorAll('.bbv-match-finder__button'),
    'collection': document.getElementById('bbv-match-finder-collection'),
    'products': document.querySelectorAll('product-card'),
    'addToCard': document.querySelector('.bbv-add-all'),
    'bottomBar': document.querySelector('.bbv-match-finder__bottom-bar'),
    'dryExceptionElements': document.querySelectorAll('[data-dry-exc]')
}

const filterSteps = () => {
    elements.steps.forEach(step => {
        step.style.display = (Number(step.dataset.step) === currentStep) ? 'flex' : 'none';
    });
}

const next = () => {
    if(currentStep < elements.steps.length) {
        currentStep++;
        filterSteps();
    }
}

const enableNext = () => {

    const target = elements.steps[currentStep].querySelector('button[data-action="next"]');
    const selectedSteps = userSelection.filter(selection => selection.step === currentStep);

    // TO DO: Remove exception
    if(currentStep !== 2) {
        return false;
    }

    if(selectedSteps.length > 0) {
        target.removeAttribute('disabled');
        return false;
    }
    
    target.setAttribute('disabled',true);
}

const back = () => {
    if(currentStep > 0) {
        currentStep--;
        filterSteps();
    }
}

const reset = () => {
    
    document.querySelectorAll('[data-selected]').forEach(option => {
        option.dataset.selected = false;
        userSelection = [];
        result = [];
    });

    elements.bottomBar.display = 'none';
    elements.collection.style.display = 'none';
    elements.products.forEach(product => {
        product.style.display = 'none';
    })

    currentStep = 0;
    cartItems = [];
    filterSteps();
}
    
const removeDuplicates = data => {
    userSelection = data.filter((option,index) => {
        return data.indexOf(option) === index;
    }); 
}

const addOptions = (index,options) => {

    // TO DO: Remove exception
    if(currentStep === 1) {
        return false;
    }

    userSelection.push({
        'id': index,
        'values': options,
        'step': currentStep,
        'remove': []
    });
}

const removeOptions = (optionsToRemove,tracking) => {
    optionsToRemove.forEach(option => {
        userSelection.forEach(selection => {
            selection.values.forEach((item,index) => {

                const parsedSelection = item.toLowerCase().replace(/ /g,'-');

                if(parsedSelection.includes(option)) {
                    switch(tracking) {
                        case 'deleteAll':
                            selection.values.splice(index,1);    
                            break;
                        case 'add':
                            selection.remove.push(parsedSelection);    
                            break;
                        case 'deleteTracking':
                            selection.remove.splice(selection.remove.indexOf(parsedSelection),1);   
                            break;
                    }
                }
            })
        })
    })
}

const parseElements = elements => elements.split(', ').map(element => element.toLowerCase().replace(/ /g,'-'));

const buildResult = () => {
    
    const result = [];
    
    userSelection.forEach(selection => {
        selection.values.forEach(value => {
            
            const parsedSelection = value.toLowerCase().replace(/ /g,'-');

            if(selection.remove.indexOf(parsedSelection) === -1 && result.indexOf(value) === -1) {
                result.push(value);
            }
        })
    });

    filterAndDisplayCollection(result);
}

const addToCart = () => {

    let formData = {
        'items': cartItems
    }
    
    fetch(SHOPIFY_API.ADD,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(response => {
        return response.json();
    }).then(cart => {
        window.location = '/cart';
    })
    .catch(error => {
        console.debug('Find Your Shade:',error);
    });
}

const filterAndDisplayCollection = result => {
    
    elements.collection.style.display = 'flex';
    elements.bottomBar.style.display = 'flex';
    
    result.forEach(productResult => {
        elements.products.forEach(product => {

            const tags = product.dataset.productTags.split('|');

            if(tags[0].trim() === productResult) {
                product.style.display = 'flex';
                cartItems.push({
                    id: product.dataset.productId,
                    quantity: 1
                });
            }
        })
    })
}

const updateDryExceptions = () => {
    elements.dryExceptionElements.forEach(element => {
        element.dataset.remove = (drySelected) ? "Clear Water" : "Clear Water, Lotion, Serum";
    });
}

const updateProBareExceptions = button => {
    userSelection.forEach(selection => {
        button.dataset.remove = (selection.values.join('-').includes('Ultra Dark')) ? "Mist" : "Foam, Mist";
    });
}

const scrollToOrigin = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

const bindInteraction = () => {

    elements.actions.forEach(action => {
        action.onclick = event => {
            switch(event.target.dataset.action) {
                case 'next':
                    next();
                    break;
                case 'show':
                    buildResult();
                    next();
                break;
                case 'start':
                    reset();
                    break;
                case 'back':
                    back();
                    break;
            }
            scrollToOrigin();
            return false;
        }
    });

    elements.buttons.forEach(button => {
        button.onclick = event => {

            const buttonData = event.target.dataset;
            const state = buttonData.selected === 'true';
            const newState = !state;
            
            buttonData.selected = newState;

            if(event.target.id === 'dry') {
                drySelected = newState;
                updateDryExceptions();
            }

            if(newState) {
                if(buttonData.addOptions) {
                    addOptions(buttonData.addOptions,options[Number(buttonData.addOptions)]);
                    enableNext();
                    console.log(userSelection);
                }
                if(buttonData.remove) {
                    removeOptions(parseElements(buttonData.remove),'add');
                    console.log(userSelection);
                }
                if(buttonData.add) {
                    addOptions(buttonData.addOptions,buttonData.add.split(', '));
                    console.log(userSelection);
                }
                // case for buttons that redirect to next step
                if(buttonData.action === 'show') {
                    buildResult();
                    next();
                }
                return;
            }
            
            if(!newState) {
                if(buttonData.addOptions || buttonData.add) {
                    userSelection = userSelection.filter(selection => selection.id !== buttonData.addOptions);
                    enableNext();
                    console.log(userSelection);
                    return;
                }
                if(buttonData.remove) {
                    removeOptions(parseElements(buttonData.remove),'deleteTracking');
                    console.log(userSelection);
                    return;
                }
            }

            return;
        }
    });

    elements.addToCard.onclick = () => {
        addToCart();
        return;
    }
}

window.onscroll = () => {

    const newsletterSection = document.querySelector('.shopify-section--newsletter').getBoundingClientRect().top;

    elements.bottomBar.dataset.off = ((newsletterSection + 200) < window.innerHeight);
}

bindInteraction();